/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useRef, useEffect } from 'react';

interface ISearchBarProps {
  value?: string;
  placeholder: string;
  maxLength?: number;
  disabled?: boolean;
  isActive?: boolean;
  onChange(text: string): void;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
}
const SearchBar: React.FunctionComponent<ISearchBarProps> = (props: ISearchBarProps) => {
  const { value, placeholder, maxLength, disabled, isActive, onChange, onBlur } = props;

  // Set Focus on input, and remove it on component unmount
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const current = inputRef?.current || null;
    current?.focus();
    return () => {
      current?.blur();
    };
  }, [isActive]);

  return (
    <div className="search-bar">
      <div className="inner-content">
        <div className="search-bar-icon" />
        <div className="inputTextWrapper" id="Search_inputWrapper">
          <input
            ref={inputRef}
            id="Search_input"
            className="form-input inputSearch"
            name="searchBar"
            value={value}
            type="text"
            maxLength={maxLength}
            placeholder={placeholder}
            onChange={(e) => {
              onChange(e.currentTarget.value);
            }}
            onBlur={onBlur}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
